import type { Language } from '@/tools/i18n'

export const citiesKeywordSlug: Record<Language, string> = {
  bg: 'gradove',
  bs: 'gradovi',
  ca: 'ciutats',
  en: 'cities',
  es: 'ciudades',
  eu: 'hiriak',
  fr: 'villes',
  hr: 'gradovi',
  hy: 'kaghakner',
  it: 'citta',
  ka: 'kalakebi',
  kk: 'qalalar',
  pl: 'miasta',
  pt: 'cidades',
  ro: 'orase',
  ru: 'goroda',
  sl: 'mesta',
  sr: 'gradovi',
  uk: 'mista',
  ky: 'шаарлар',
}
